import React, {useState} from "react";
import {Button, Form, Icon, Message} from "semantic-ui-react";

function DialogConversationAdder(
    {
        handleSetDialogConversationData
    }
) {


    return (
        <>
            <div style={{marginTop: 10, marginRight: 5, marginLeft: 5}}>
                <div style={{border: ' 3px solid', textAlign: 'left', width: 800}}>
                    <Message attached header="Dialog Conversation Assignment" style={{paddingLeft: 10, paddingRight: 10,}}/>
                    <Form className='attached fluid segment'>
                        <Form.Group widths='equal'>
                            <Form.Input label='Sounds' multiple type='file' name='audio'
                                        onChange={handleSetDialogConversationData}/>
                            <Form.Input label='JSON File' type='file' name='assignment'
                                        onChange={handleSetDialogConversationData}/>

                        </Form.Group>


                    </Form>
                </div>
            </div>
        </>
    )
}

export default DialogConversationAdder
